import "./Progress.css"

const Progress = ({ value = 0, max = 100, className = "", ...props }) => {
  const percentage = Math.min(Math.max(value, 0), max)
  const width = `${(percentage / max) * 100}%`

  return (
    <div className={`progress ${className}`} {...props}>
      <div className="progress-bar" style={{ width }} />
    </div>
  )
}

export default Progress

